<template>
    <comment-body :comment="reply">
        <a-button v-if="parent.locked == 0" type="link" @click="replyThis()">回复</a-button>
        <a-button v-if="userid == reply.author.id" type="link" @click="deleteSubcomment()">删除</a-button>
        <a-button class="admin-button" v-else-if="hasDeletePrivilege" type="link" @click="deleteSubcommentByAdmin()">删除</a-button>
    </comment-body>
</template>

<script>
import { checkPrivilege } from '../../admin/privilege';
import { mapState } from 'vuex';
import CommentBody from './CommentBody.vue';

export default {
    props: {
        reply: Object,
        parent: Object,
    },
    inject: [ 'commentBoard' ],
    computed: {
        ...mapState({ userid: 'userid', userPrivilege: 'privilege' }),
        mobile() {
            return this._mobile;
        },
        hasDeletePrivilege() {
            return checkPrivilege({ comment: 3 }, this.userPrivilege);
        },
        content() {
            return this.parse(this.reply.comment);
        },
    },
    methods: {
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        },
        replyThis() {
            this.$emit('reply', this.reply);
        },
        async deleteSubcomment() {
            const { id } = this.reply;
            await this.commentBoard.deleteComment(id);
        },
        async deleteSubcommentByAdmin() {
            const { id } = this.reply;
            await this.commentBoard.deleteCommentByAdmin(id);
        },
    },
    components: {
        CommentBody,
    }
}
</script>

<style lang="less" scope>
.ant-btn {
    span {
        margin: 0px;
    }
    padding: 0 6px;
    &.admin-button {
        color: grey;
    }
}
</style>